import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('Trajectory Error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          flex:1, display:'flex', flexDirection:'column', alignItems:'center',
          justifyContent:'center', padding:'40px', background:'var(--bg)',
          gap:'16px', textAlign:'center'
        }}>
          <div style={{fontSize:'48px'}}>⚠️</div>
          <h2 style={{fontSize:'20px', fontWeight:'700', color:'var(--text)'}}>Something went wrong</h2>
          <p style={{fontSize:'13px', color:'var(--muted)', maxWidth:'400px', lineHeight:1.6}}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <div style={{display:'flex', gap:'10px'}}>
            <button
              onClick={() => { this.setState({hasError:false,error:null}); window.history.back(); }}
              style={{padding:'8px 20px', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600'}}>
              ← Go Back
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{padding:'8px 20px', background:'var(--brand)', color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600'}}>
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
